<template>
    <div id="ordersrootpopup">
        <vs-popup title="" 
        :button-close-hidden="true" 
        :active.sync="isActive"
        @close="$emit('isActiveFalse')"
        style="border-radius: 10px !important;"
        id="popUpOrdersChat"
        >
            <div>
                <span id="display-span-orders">
                    <!--<vs-icon class="mr-2" icon="keyboard_arrow_left" style="border: solid 1px; border-radius: 14px; cursor: pointer;"/>-->
                    <p class="ml-6" style="font-size: 16px;">Pedidos</p>
                    <div class="flex-end-align">
                        <vs-icon @click="closePopUp" class="mr-2" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right;"></vs-icon>
                    </div>
                </span>
            </div>
            
            <orders-table
                ref="ordersTable"
                @closePopup="closePopUp"
            ></orders-table>

        </vs-popup>
    </div>
</template>

<script>
    import ProductOrdersChildrensVue from "@/views/orders/product-orders/ProductOrdersChildrens.vue";
    import OrdersTable from "./OrdersTable";

    export default {
        name: 'OrdersPopUp',
        components: {
            ProductOrdersChildrensVue,
            OrdersTable
        },
        data() {
            return {
                statuses: [],
                search: '',
                orderBy: {
                    name: 'chat_tickets.customers.name',
                    type: 'ASC'
                },
                modalToFinishOrder: false,
                targetToFinish: 0,
                page: 1,
                itemsPerPage: 4,
                isMounted: false
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        methods: {
            async dataLoad() {
                await this.$refs.ordersTable.dataLoad();
            },
            closePopUp() {
                this.isActive = false;
                this.$emit('isActiveFalse');
            }
        },
        watch: {
            isActive() {
                this.dataLoad();
            },
        },
        async mounted() {
            this.$store.dispatch('setShowLoadingOverlay', false)

            await this.dataLoad();
            this.isMounted = true;
        }
    }
</script>

<style lang="scss">
    #popUpOrdersChat div.vs-popup {
        .vs-popup--content {
            padding: 15px;
            margin: 0;
        }
        margin: 0;
        border-radius: 18px !important;
        border: solid 1.2px;
        border-color: rgba(18, 17, 17, 0.769);
        width: 950px !important;
        .vs-popup--header {
            background-color: transparent !important;
            .vs-popup--title {
                background-color: transparent !important;
                h3 {
                    background-color: transparent !important;
                }
            }
        }
        header {
            background-color: transparent !important;

        }
    }
    #display-span-orders {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        div {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            i.vs-icon.notranslate.icon-scale.mr-2.material-icons.null:last-of-type {
                cursor: pointer;
            }
        }
    }
    #tableDataOrdersChat {
        .vs-con-tbody.vs-table--tbody {
            background-color: transparent !important;
            border: 0 !important; 
        }
        table.vs-table.vs-table--tbody-table {
            border-collapse: separate;
            border-spacing: 0 0.5rem;
            padding: 0 1rem;
        }
        header {
            margin-left: 16px;
            margin-right: 16px;
            div > input {
                border: solid 0.1px !important;
                color: #726f6fb4;
            }
        }
        tbody {  
            tr {
                .align-button-flex {
                    .vs-button-text.vs-button--text {
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        align-items: center;
                        padding-left: 10px;
                    }
                }
                td {
                    padding: 0px;
                    border-style: solid; 
                    border-color: #b6bebd6e;
                    padding-right: 6px;
                    height: 4em;
                }
                .td-check {
                    height: 5em !important;
                }
                td.td-check.active-expanded {
                    display: flex;
                    flex-direction: row;
                    align-content: center;
                    flex-wrap: wrap;
                }
                td:first-of-type {
                    border-top-left-radius: 14px; 
                    border-bottom-left-radius: 14px; 
                    border-width: 1px 0px 1px 1px;
                }
                td:nth-of-type(2), td:nth-of-type(3), td:nth-of-type(4), td:nth-of-type(5) {
                    border-width: 1px 0px 1px 0px; 
                }
                td:last-of-type {
                    border-width: 1px 1px 1px 0px;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    padding-right: 10px;
                }
            }
        }
    }
    tr.tr-expand {
        > td {
            border: 0 !important;
            div.content-tr-expand {
                border: 0 !important;
                align-items: flex-end;
                .order-infos-div {
                    display: flex;
                    div {
                        border: solid 2px #abb3b257; 
                        border-radius: 14px;
                        cursor: pointer;
                        margin: 8px;
                        width: 90px;
                        height: 80px;
                        display: flex;
                        flex-direction: column;
                        align-content: center;
                        justify-content: center;
                        align-items: center;
                        flex-wrap: wrap;

                        span {
                            font-size: 10px;
                            text-align: center;
                        }
                        img {
                            width: 40px;
                            height: 40px;
                            border-radius: 40px;
                        }
                    }
                }
            }
        }
    }
    span#alignVsChip {
        display: flex;
        justify-content: center;
    }
    .formatHeadName {
        //transform: translateX(3.5em);
    }
    .formatHead {
        //transform: translateX(6em);
    }
    .formatHeadStatus {
        //transform: translateX(8em);
    }
    .format {
        //transform: translateX(8em);
    }

    
</style>